import axios from "../../axios/axios-censo";
import axiosRoot from "../../axios/axios-root";

export const pegaListaUnidades = ({ commit }) => {
    commit("sessao/setLoading", true, { root: true })
    return axios
    .get("listarUnidadesFiltro.php")
    .then(resp => {
        commit("sessao/setLoading", false, { root: true })
        commit("setListaUnidades", resp.data.dados)
    })
    .catch(error => {
        commit("sessao/setLoading", false, { root: true })
        console.log(error)
    });
}


export const pegaListagemEnfermarias = ({ commit }, payload) => {

    let config = {
        params: {
          cnes: payload
        }
    }

    return axiosRoot
    .get("publico/controller/listarEnfermarias.php", config)
    .then(resp => {
        if (resp.data.status == true) commit("setListagemEnfermarias", resp.data.dados)
    })
    .catch(error => {
        console.log(error)
    });
}